import React from 'react';
import VideoTemplate from '../components/video/VideoTemplate';

export default function ViystrVideo() {
  return (
    <div className="w-full h-[100dvh] bg-[#F9F9F7]">
      <VideoTemplate />
    </div>
  );
}
